import { SubpageLayout2018 } from '../subpageLayout';

const members = [
  { name: '林潔貽女士, JP, FCILT', title: '香港貨品編碼協會總裁', image: '/2018/images/advisory_member-1.jpg', id: 'member_1' },
  { name: '方健僑博士', title: '香港無線科技商會永遠名譽主席', image: '/2018/images/advisory_member-2.jpg', id: 'member_2' },
  { name: '湛家揚博士', title: '香港數碼港管理有限公司公眾使命總監', image: '/2018/images/advisory_member-3.jpg', id: 'member_3' },
  { name: '楊天寵工程師', title: '香港科技園公司總監 - 電子、信息及通訊科技群組,智慧城市科技平台', image: '/2018/images/advisory_member-4.jpg', id: 'member_4' },
  { name: '畢堅文先生', title: '生產力局總裁', image: '/2018/images/advisory_member-5.jpg', id: 'member_5' },
  { name: '莫家豪教授', title: '嶺南大學副校長', image: '/2018/images/advisory_member-6.jpg', id: 'member_6' },
];

export default function Advisory2018Zh() {
  return (
    <SubpageLayout2018 lang="zh" title="諮詢委員會" page="advisory">
      <div className="para_introduction advisory-page">
        <h1>諮詢委員會</h1>
        <div className="center_introduction">
          <p className="p1"></p>
        </div>
        <div className="head_advisory_container">
          <div className="head_advisory_photo_container_responsive">
            <div className="head_advisory_photo">
              <img src="/2018/images/advisory_head.jpg" alt="" />
            </div>
          </div>
          <div className="head_advisory_text_container animate" data-animate="slideInRight" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="head_advisory_subject">諮詢委員會主席</div>
            <div className="head_advisory_name">鄧淑明博士, JP</div>
            <div className="head_advisory_title">智慧城市聯盟創辦人及榮譽會長</div>
            <div className="head_advisory_text">
              鄧淑明博士，太平紳士，香港大學計算機科學系榮譽教授，香港土生土長培育的資訊科技界企業家。鄧博士於九十年代創辦 Esri中國（香港）有限公司，專門推廣地理資訊系統(GIS)軟件和提供相關解決方案。鄧博士一直積極參與多個政府及民間組織，致力促進香港科技及社會事務發展。她的貢獻廣受認同並獲多項榮譽，包括：香港大學2009年理學院傑出校友、2006年香港十大傑出青年及香港美國商會2004年「最具影響力女性獎 ─ 年度傑出女青」等。
            </div>
          </div>
          <div className="head_advisory_photo_container animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="head_advisory_photo">
              <img src="/2018/images/advisory_head.jpg" alt="" />
            </div>
          </div>
        </div>
        <div className="board_members_container_bg">
          <div className="board_members_container animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="board_members_subject" style={{ fontSize: 36, fontWeight: 'bold', marginBottom: 10 }}>諮詢委員會成員</div>
            <div className="member_all">
              {members.map((m) => (
                <div className={`member ${m.id.replace('_', '_')}`} id={m.id} key={m.id}>
                  <div className="member_photo">
                    <img src={m.image} alt="" />
                  </div>
                  <div className="member_text_container">
                    <div className="member_text_name" style={{ fontSize: 20, fontWeight: 'bold' }}>{m.name}</div>
                    <div className="member_text_title" style={{ fontSize: 16, fontWeight: 100 }}>{m.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

